import React from "react";
import FormCollectiveGroupingAgreementContextProvider, {
    FormCollectiveGroupingAgreementContext,
    ACTIONS
} from "../../context/FormCollectiveGroupingAgreementContextProvider";
import Loading from "../../../../common/components/Loading";
import { CGE } from "../../../../common/components/CGE"
import { ClayCheckbox } from "@clayui/form";
import FileUploaded from "../../../../common/components/FileUploader";
import { beforeMaskedValueChangeRut, decode_utf8, isRutValid, transformId, validateCell } from '../../../../common/utils/utilsFunc'
import { useModal } from "@clayui/modal";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';


const FormCollectiveGroupingAgreement = ({ props }) => {

    const [state, dispatch] = React.useContext(FormCollectiveGroupingAgreementContext);
    const [loading, setLoading] = React.useState(false);
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [selectedFile, setSelectedFile] = React.useState();
    const [erroUploadFile, setErroUploadFile] = React.useState();
    const [detailClientJson, setDetailClientJson] = React.useState([]);
    //<form
    const [inputForms, setInputForms] = React.useState({});
    const [inputValidate, setInputValidate] = React.useState({
        empty: {},
        error: {},
        msg: {}
    });
    const [termCond, setTermCond] = React.useState(false);
    const [listOptions, setListOptions] = React.useState([]);
    const [visibleModal, setVisibleModal] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        },
    });
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    let propsLabelInfoContent = {
        "content": state?.webContentTextInfo,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModal,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModal,
        "titleHint": "Ayuda Nro de Cliente",
    }
    //<form

    function initialState() {
        setInputForms({
            "comuna": "",
            "calle": "",
            "number": "",
            "dpto": "",
            "typeVulnerability": inputForms.typeVulnerability.length > 1 ? "" : inputForms.typeVulnerability,
            "numberClient": "",
            "rut": "",
            "name": "",
            "nameFather": "",
            "nameMother": "",
            "email": "",
            "tel": "",
            "qtdFamily": ""
        });
        setInputValidate({
            empty: {},
            error: {},
            msg: {}
        });
        setTermCond(false);
        cleanFile();
        setDetailClientJson([]);
        dispatch({
            type: ACTIONS.SET_CTA_CTO,
            payload: ""
        })
    }

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function validateForms() {
        let errors = {
            empty: {},
            error: {},
            msg: {}
        };
        
        if (!inputForms.numberClient) {
            errors.empty.numberClient = true;
            errors.msg.numberClient = "Debes ingresar un Nro. de Cliente";
        } else if (inputForms.numberClient && !inputForms.comuna) {
            errors.empty.numberClient = true;
            errors.msg.numberClient = "Debes presionar buscar número de cliente";
        }
        
        if (selectedFile?.certif) {
            errors.empty.selectedFile = false;
        } else {
            errors.empty.selectedFile = true;
            errors.msg.selectedFile = "Debes adjuntar el certificados de Registro Social de Hogares"
        }

        if (inputForms.rut) {
            errors.empty.rut = false;

            if (!isRutValid(inputForms.rut)) {
                errors.error.rut = true;
                errors.msg.rut = "Debes ingresar un RUT válido.";
            } else {
                errors.error.rut = false;
            }

        } else {
            errors.empty.rut = true;
            errors.msg.rut = "Debes ingresar el RUT del solicitante.";
        }

        if (inputForms.name) {
            errors.empty.name = false;
        } else {
            errors.empty.name = true;
            errors.msg.name = "Debes ingresar el nombre y apellido";
        }


        if (inputForms.nameFather) {
            errors.empty.nameFather = false;
        } else {
            errors.empty.nameFather = true;
            errors.msg.nameFather = "Debes ingresar el apellido paterno";
        }

        if (inputForms.nameMother) {
            errors.empty.nameMother = false;
        } else {
            errors.empty.nameMother = true;
            errors.msg.nameMother = "Debes ingresar el apellido materno";
        }

        if (inputForms.nameMother) {
            errors.empty.nameMother = false;
        } else {
            errors.empty.nameMother = true;
            errors.msg.nameMother = "Debes ingresar el apellido materno";
        }

        if (inputForms.tel) {
            errors.empty.tel = false;
            if (validateCell(inputForms.tel)) {
                errors.error.tel = true;
                errors.msg.tel = "Debes ingresar un teléfono válido"
            } else {
                errors.error.tel = false;
            }
        } else {
            errors.empty.tel = true;
            errors.msg.tel = "Debes ingresar el teléfono del solicitante"
        }

        if (inputForms.email) {
            errors.empty.email = false;
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputForms.email)) {
                errors.error.email = true;
                errors.msg.email = "Debes ingresar un correo electrónico válido";
            } else {
                errors.error.email = false;
            }

        } else {
            errors.empty.email = true;
            errors.msg.email = "Debes ingresar el correo electrónico del solicitante";
        }
        
        if (inputForms.typeVulnerability) {
            errors.empty.typeVulnerability = false;
        } else {
            errors.empty.typeVulnerability = true;
            errors.msg.typeVulnerability = "Debes ingresar el tipo de vulnerabilidad";
        }

        if (Number(inputForms.qtdFamily) && ( Number(inputForms.qtdFamily) >= 2 && Number(inputForms.qtdFamily) <= 500 )) {
            errors.empty.qtdFamily = false;
        } else {
            errors.empty.qtdFamily = true;
            errors.msg.qtdFamily = "Debes ingresar un valor entre 2 y 500 para la cantidad de familias";
        }
        
        setInputValidate(errors);
        return errors;
    }

    function cleanFile() {
        let inputFile = document.querySelector(`#inputFileCertf`);
        inputFile.value = '';
        setSelectedFile({ ...selectedFile, 'certif': '' });
    }
    
    function funcSend() {
        const objErros = validateForms();
        let errorMsgLocal = Object.values(objErros?.msg).toString().replaceAll(",", ". ");
        if (errorMsgLocal) {
            props.setGlobalAlert("Complete todos los campos obligatorios", "warning");
        } else if (!selectedFile){
            props.setGlobalAlert("Debes adjuntar el archivo solicitado, correspondiente al Certificados de Registro Social de Hogares", "warning");
        } else if (!termCond) {
            props.setGlobalAlert("Debes aceptar los términos y condiciones", "warning");

        } else if (!verifReCaptcha) {
            props.setGlobalAlert("Falta validar que no eres un Robot.", "warning");
        }   else if (transformId(state.idClientAux) !== transformId(inputForms.numberClient) ) {
        props.setGlobalAlert("Debes realizar la búsqueda del número de cliente.","warning");
        } else {
            setLoading(true);
            dispatch({
                type: ACTIONS.SET_FORM,
                payload: {form:inputForms,file:selectedFile,detailClient:detailClientJson}
            })
        }
    }

    React.useEffect(() => {
        if(erroUploadFile) {
            props.setGlobalAlert(erroUploadFile, "warning");
        }
    },[erroUploadFile]);
    
    React.useEffect(() => {
        let optionAux = [];
        const auxListResponse = state.listOptions?.tipoSolicitud;

        if(auxListResponse?.length > 0) {
            if(auxListResponse?.length > 1) {
                optionAux.push({ label: "Selecione una opción", value: "" });
            }
            auxListResponse?.forEach((item) => {
                optionAux.push({ label: item.nombre, value: item.id });
                setInputForms({ ...inputForms, typeVulnerability: item.id });
            });
        }
        setListOptions(optionAux);
    },[state.listOptions])

    function handleClickButtonClient() {
        if (inputForms.numberClient) {
            setLoading(true)
            dispatch({
                type: ACTIONS.SET_CTA_CTO,
                payload: inputForms.numberClient
            })
        } else {
            props.setGlobalAlert("Debes ingresar un número de cliente","warning");
        }
    }

    React.useEffect(() => {
        if(state.detailClient){
          setLoading(false)
          if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN || state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
            if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0){
              setDetailClientJson(state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM)
            } else {
                setDetailClientJson([])
                props.setGlobalAlert(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN ? state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN : decode_utf8(props.text_fetch_error) ,"warning", true, "Advertencia");
            }
          } else {
            setDetailClientJson([])
            props.setGlobalAlert(decode_utf8(props.text_fetch_error),"warning", true, "Advertencia");
          }
        }
    }, [state.detailClient])

    React.useEffect(() => {
        if (detailClientJson) {
            setInputForms({ ...inputForms, comuna: detailClientJson?.COMUNA, calle: detailClientJson?.CALLE, number: detailClientJson?.NUMERO_CASA, dpto: `${detailClientJson?.SUPLEMENTO}` })
        }
    }, [detailClientJson]);

    React.useEffect(() => {
        const objResponse = state.response_serv2?.data;
        setLoading(false);
        if(objResponse) {
            if(objResponse.code === 0 && objResponse.message) {
                props.setGlobalAlert(objResponse.message, "success",true,"Confirmación");
                initialState();
            } else if(objResponse.code !== 0 && objResponse.message) {
                props.setGlobalAlert(objResponse.message, "warning",true,"Atención");
            } else {
                props.setGlobalAlert("El servicio no está disponible actualmente, intente más tarde.", "warning",true,"Atención");
            }
        }
        
    },[state.response_serv2]);
    
    return (
        <div
            id="container"
        >
            <CGE.Panel title={decode_utf8(props.title_form_collective_grouping_agreement)}>
                <CGE.PanelSection title={decode_utf8(props.subtitle1_form_collective_grouping_agreement)}>
                    <div className="row">
                        <div className="col-md-12">
                            <CGE.DetailClient
                                props={{
                                    handleChange: (e) => setInputForms({ ...inputForms, numberClient: e.target.value }),
                                    hasError: inputValidate?.empty?.numberClient,
                                    msgError: inputValidate?.msg?.numberClient,
                                    idClient: inputForms.numberClient,
                                    idFormElement: "numberClient",
                                    labelName: "Número de Cliente",
                                    placeholder: "Número de Cliente",
                                    mandatoryElement: true,
                                    valuePub: inputForms.numberClient,
                                    labelButton: "Buscar",
                                    handleClick: () => { handleClickButtonClient() },
                                    sizeButton: "sm",
                                    typeButton: "primary",
                                    propsLabelInfoContent:propsLabelInfoContent
                                }}
                                
                                propsDetail={{
                                    fullNameClient: "",
                                    comunaClient: detailClientJson?.COMUNA ? detailClientJson?.COMUNA : "",
                                    calleClient: detailClientJson?.CALLE ? detailClientJson?.CALLE : "",
                                    nCalleClient: detailClientJson?.NUMERO_CASA ? detailClientJson?.NUMERO_CASA : "",
                                    dptoBlockClient: (detailClientJson?.SUPLEMENTO || detailClientJson?.PISO) ? `${detailClientJson?.SUPLEMENTO} 
                                ${detailClientJson?.PISO}` : "",
                                    ctaCtoClient: detailClientJson?.CTA_CTO
                                }}
                            />
                        </div>

                    </div>
                </CGE.PanelSection>

                <CGE.PanelSection title={decode_utf8(props.subtitle2_form_collective_grouping_agreement)}>  
                    <div className="row">
                        <div className="col-md-6">
                            <CGE.FormsField
                                labelName="RUT/Nº de Carnet de identidad:"
                                handleChange={({ target }) => {
                                    setInputForms({ ...inputForms, rut: target.value })
                                }}
                                idFormElement="inputRut"
                                typeFormElement="text"
                                placeholder="Rut (Ej: 12345678-9)"
                                mandatoryElement={true}
                                hasError={inputValidate.error.rut || inputValidate.empty.rut}
                                msgError={inputValidate.msg.rut}
                                value={inputForms.rut}
                                typeElement="input-mask"
                                beforeMaskedValueChange={beforeMaskedValueChangeRut}
                                formatChars={{
                                    "9": "[0-9]",
                                    k: "[Kk0-9]",
                                }}
                                mask="9.999.999-kk"
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                labelName="Nombre del solicitante y/o deudor"
                                handleChange={({ target }) => {
                                    setInputForms({ ...inputForms, name: target.value })
                                }}
                                idFormElement="inputName"
                                typeFormElement="text"
                                typeElement="input"
                                placeholder="Nombres"
                                mandatoryElement={true}
                                hasError={inputValidate.error.name || inputValidate.empty.name}
                                msgError={inputValidate.msg.name}
                                value={inputForms.name}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <CGE.FormsField
                                labelName="Apellido Paterno"
                                handleChange={({ target }) => {
                                    setInputForms({ ...inputForms, nameFather: target.value })
                                }}
                                idFormElement="inputNameFather"
                                typeFormElement="text"
                                typeElement="input"
                                placeholder="Apellido Paterno"
                                mandatoryElement={true}
                                hasError={inputValidate.error.nameFather || inputValidate.empty.nameFather}
                                msgError={inputValidate.msg.nameFather}
                                value={inputForms.nameFather}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                labelName="Apellido Materno"
                                handleChange={({ target }) => {
                                    setInputForms({ ...inputForms, nameMother: target.value })
                                }}
                                idFormElement="inputNameMother"
                                typeFormElement="text"
                                typeElement="input"
                                placeholder="Apellido Materno"
                                mandatoryElement={true}
                                hasError={inputValidate.error.nameMother || inputValidate.empty.nameMother}
                                msgError={inputValidate.msg.nameMother}
                                value={inputForms.nameMother}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <CGE.FormsField
                                labelName="Correo electrónico"
                                handleChange={({ target }) => {
                                    setInputForms({ ...inputForms, email: target.value });
                                }}
                                idFormElement="inputEmail"
                                typeFormElement="text"
                                typeElement="input"
                                placeholder="Email"
                                mandatoryElement={true}
                                hasError={inputValidate.error.email || inputValidate.empty.email}
                                msgError={inputValidate.msg.email}
                                value={inputForms.email}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                labelName="Teléfono"
                                handleChange={({ target }) => {
                                    setInputForms({ ...inputForms, tel: target.value });
                                }}
                                idFormElement="inputTel"
                                typeFormElement="text"
                                placeholder="(Ej: 912345678)"
                                minLength="9"
                                maxLength="9"
                                typeElement="input-mask"
                                formatChars={{
                                    9: "[0-9]",
                                }}
                                mask="999999999"
                                maskChar={null}
                                mandatoryElement={true}
                                hasError={inputValidate.error.tel || inputValidate.empty.tel}
                                msgError={inputValidate.msg.tel}
                                value={inputForms.tel}

                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={({ target }) => {
                                    setInputForms({ ...inputForms, typeVulnerability: target.value });
                                }}
                                hasError={inputValidate.error.typeVulnerability || inputValidate.empty.typeVulnerability}
                                msgError={inputValidate.msg.typeVulnerability}
                              idFormElement="inputTypeVulnerability"
                              labelName="Tipo de vulnerabilidad a acreditar"
                              listOptions={listOptions}
                              mandatoryElement={true}
                              typeElement="select"
                              typeFormElement="text"
                              value={listOptions.length > 1 ? "" : inputForms.typeVulnerability}
                              disabled={listOptions.length === 1}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                className="grid-1"
                                labelName="Cantidad de Familias en grupo colectivo"
                                handleChange={({ target }) => {
                                    setInputForms({ ...inputForms, qtdFamily: target.value });
                                }}
                                idFormElement="inputQtdFamily"
                                typeFormElement="text"
                                placeholder="2 - 500"
                                mandatoryElement={true}
                                hasError={inputValidate.error.qtdFamily || inputValidate.empty.qtdFamily}
                                msgError={inputValidate.msg.qtdFamily}
                                value={inputForms.qtdFamily}
                                typeElement="input"
                                maxLength="3"
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                            />
                        </div>
                    </div>

                    <CGE.Text text="Adjuntar la siguiente documentación requerida, los archivos deben ser PDF o imágenes y no superar 2 MB" size="1" /> 
                    
                    <FileUploaded
                        idInput="inputFileCertf"
                        labelInput="Certificados de Registro Social de Hogares"
                        deleteFile={() => cleanFile()}
                        onFileSelectSuccess={(file) => setSelectedFile({ ...selectedFile, 'certif': file })}
                        setErroUploadFile={setErroUploadFile}
                        dataProps={props}
                        mandatoryElement={true}
                        maxFileSize={props.tamano_maximo_de_archivo_MB}
                        typeFile={props?.documento_extension}
                        msgErrorFileSize={decode_utf8(props?.erro_documento_tamano)}
                        multiFiles={false}
                        hasError={inputValidate?.empty?.selectedFile}
                        msgError={inputValidate?.msg?.selectedFile}
                    />
                </CGE.PanelSection>

                <CGE.PanelSection title={decode_utf8(props.subtitle3_form_collective_grouping_agreement)}>
                    <div className="row">
                        <CGE.RenderContent textContent={state?.webContentTerm} />
                        <div className="col-md-12 px-0 py-0">
                                <CGE.FormsField
                                    checked={termCond}
                                    labelName="Acepto los términos y condiciones"
                                    handleChange={() => setTermCond(val => !val)}
                                    idFormElement="numberClientId"
                                    typeFormElement="checkbox"
                                    mandatoryElement={true}
                                    typeElement="input"
                                />
                        </div>
                        <div className="col-md-12 px-0">
                        <CGE.FieldRecaptcha
                            onChange={onChangeReCaptcha}
                            sitekey={props.api_key_recaptcha}
                        />
                        </div>
                    </div>
                </CGE.PanelSection>
           
                <div className="d-flex justify-content-end">
                    <CGE.Button
                        label="Enviar"
                        onClick={() => { funcSend() }}
                        type="primary"
                    />
                </div>
            </CGE.Panel>
            {loading && <Loading />}
        </div>
    );
};

const FormCollectiveGroupingAgreementWithProvider = ({ props }) => (
    <FormCollectiveGroupingAgreementContextProvider>
        <FormCollectiveGroupingAgreement props={props} />
    </FormCollectiveGroupingAgreementContextProvider>
);
export default FormCollectiveGroupingAgreementWithProvider;